import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { TColors } from './themes';

export const Wrapper = styled.div`
    flex-direction: column;
    width: 100%;
    background: ${({ theme }) => theme.background};
    border: 1px solid ${({ theme }) => theme.border ? theme.border : COLORS.GRAY_LIGHT};
    border-width: ${({ theme }) => theme.borderWidth};
    border-radius: ${({ theme }) => theme.radius};
    padding: ${({ theme }) => theme.padding};
    color: ${({ theme }) => theme.color ? theme.color : COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: ${({ theme })=> theme.mobilePadding};
        border-radius: ${({ theme }) => theme.mobileRadius};
    }
`;

export const TitleContainer = styled.div`
    ${FONTS.L};
    width: 100%;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
    }
`;

export const Title = styled.div`
    flex-grow: 1;
    width: calc(100% - 53px);  
    ${({ theme }) => theme.desktopFont || ''};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: calc(100% - 39px);
        ${({ theme }) => theme.mobileFont || ''};
    }
`;

export const Icon = styled.span<{
    isOpen?: boolean,
    arrowColor?: TColors | string,
    iconBorder?: TColors | string,
    iconBackground?: TColors | string,
}>`
    position: relative;
    transform: ${({ isOpen }) => isOpen ? 'scaleY(-1)' : 'none'};
    transition: all 0.2s ease-in;
    svg {
        display: block;
        circle {
            stroke: ${({ iconBorder }) => iconBorder ?? COLORS.GRAY_DARK};
            fill: ${({ iconBackground }) => iconBackground ?? COLORS.GRAY_LIGHT};
        }
        path {
            stroke: ${({ arrowColor }) => arrowColor ?? COLORS.GRAY_DARK};
        }
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        background-size: contain;
    }
`;

export const Border = styled.div`
    height: 1px;
    width: 100%;
    background: transparent;
    margin: 8px 0;
`;

export const Body = styled.div<{ isOpen: boolean }>`
    width: 100%;
    max-height: ${({ isOpen }) => isOpen ? '100%' : '0'};
    ${FONTS.S};
    overflow: hidden;
    transition: max-height 0.2s ${({ isOpen }) => isOpen ? 'ease-in' : 'ease-out'};

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.XS};
    }
`;
